import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { msalInstance } from '../../../azure/azureConfig'
import { nullifyUserState } from '../../../redux/userSlice'

export const LogoutButton = ({className = ""}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const logoutHandler = async () => {
    // only our own key - clearing everything would wipe the msal cache it needs to sign out
    localStorage.removeItem('userRole')
    dispatch(nullifyUserState)
    msalInstance.logoutRedirect()
  }

  return (
    <button className={className} onClick={logoutHandler}>
      {t(`signOut`)}
    </button>
  )
}